module.exports = __webpack_public_path__ + "static/img/user-bg.46291313.jpg";